<template>
	<div class="products-list">
		<h3>Products Listing</h3>

		<router-link to="/export-products" class="product-buttons">
			<div class="button">
				Export Products
			</div>
		</router-link>

		<!-- <router-link to="/import-products" class="product-buttons">
			<div class="button">
				Import Products
			</div>
		</router-link> -->

		<router-link to="/check-products" class="product-buttons">
			<div class="button">
				Check Products
			</div>
		</router-link>

		<router-link to="/check-promotions" class="product-buttons">
			<div class="button">
				Check Promotions
			</div>
		</router-link>

		<!-- hid this button because chemicals cannot be imported. However, other import codes are done -->
		<!-- <router-link to="/update-products" class="product-buttons">
			<div class="button">
				UPDATE PRODUCTS
			</div>
		</router-link> -->

		<br />
		<br />

		<div class="productSearch">
			<div>
				<input name="searchProductName" placeholder="Product Name" v-model="searchProductName" v-on:keyup.enter="getProducts" autocomplete="off" />
			</div>

			<!-- <div>
				<input name="searchBdCode" placeholder="BD Code" v-model="searchBdCode" v-on:keyup.enter="getProducts" autocomplete="off" />
			</div> -->

			<div>
				<input name="searchBarcode" placeholder="Barcode" v-model="searchBarcode" v-on:keyup.enter="getProducts" autocomplete="off" />
			</div>

			<div>
				<b-field>
					<b-autocomplete
						v-model="searchChemicalName"
						:data="filteredChemicals"
						placeholder="Search Chemical"
						field="name"
						:loading="isLoadingChemicals"
						@typing="getFilteredChemicals"
						@select="onChemicalSelect"
					>
						<template slot="empty">No chemicals found</template>
					</b-autocomplete>
				</b-field>
			</div>

			<div>
				<input name="searchStock" placeholder="Stock (max)" v-model="searchStock" v-on:keyup.enter="getProducts" autocomplete="off" />
			</div>

			<div @click="getProducts" class="button">
				Search
			</div>

			<div class="deleteIcon">
				<span @click="refreshSearch">
					<ios-close-icon w="40px" h="40px" />
				</span>
			</div>
		</div>

		<div class="products">
			<div class="header"></div>
			<div class="product-item header">
				<div>Name</div>
				<div>BD Code</div>
				<div>Barcode</div>
				<div>Stock</div>
				<div>Price</div>
				<div>Copy</div>
			</div>
		</div>

		<div v-for="(item, index) of products" v-bind:key="index" class="products">
			<div class="indexNumber">{{ getItemIndex(index) }}</div>
			<div>
				<div class="product-item">
					<div class="textWithPadding">{{ item.name }}</div>
					<div class="textWithPadding">{{ item.bd_code }}</div>
					<div class="textWithPadding">{{ item.barcode }}</div>
					<div class="textWithPadding">
						{{ item.stock }}<br />
						<span class="unit-light">
							{{ item.packaging && item.packaging.base_unit ? item.packaging.base_unit : 'pcs' }}
						</span>
					</div>
					<div class="price">
						<span v-if="item.packaging && item.packaging.box && item.packaging.box.price">
							Box: {{ item.packaging.box.price.toLocaleString('en-GB') }}
						</span>
						<span v-if="item.packaging && item.packaging.card && item.packaging.card.price">
							<span v-if="item.packaging.box && item.packaging.box.price"> | </span>
							Card: {{ item.packaging.card.price.toLocaleString('en-GB') }}
						</span>
						<span v-if="item.packaging && item.packaging.pill && item.packaging.pill.price">
							<span v-if="(item.packaging.box && item.packaging.box.price) || (item.packaging.card && item.packaging.card.price)"> | </span>
							Pill: {{ item.packaging.pill.price.toLocaleString('en-GB') }}
						</span>
						<span
							v-if="
								!(
									item.packaging &&
									((item.packaging.box && item.packaging.box.price) ||
										(item.packaging.card && item.packaging.card.price) ||
										(item.packaging.pill && item.packaging.pill.price))
								)
							"
						>
							{{ item.stock }}
						</span>
					</div>
					<div class="textWithPadding hyperlink" @click="copyBarcode(item.barcode)">
						<ios-copy-icon w="24px" h="24px" />
					</div>
				</div>
			</div>
		</div>

		<div class="pager">
			<paginate
				v-model="page"
				:page-count="pageCount"
				:click-handler="pagerClick"
				:prev-text="'prev'"
				:next-text="'next'"
				:container-class="'pagination'"
				v-if="displayPager"
			>
			</paginate>
		</div>
	</div>
</template>

<script>
// @ is an alias to /src

export default {
	name: 'productsList',
	data: function() {
		return {
			limit: this.$config.pageItemsLimit,
			pageCount: 1,
			page: 1,
			searchProductName: null,
			searchBdCode: null,
			searchBarcode: null,
			searchStock: null,
			displayPager: true,
			products: [],
			// Chemical dropdown data
			searchChemicalName: '',
			selectedChemical: null,
			allChemicals: [],
			filteredChemicals: [],
			isLoadingChemicals: false
		}
	},
	mounted: async function() {
		this.getProducts()
		this.loadChemicals()
	},
	methods: {
		// Copy barcode into cart
		copyBarcode: function(barcode) {
			if (barcode) {
				this.$store.dispatch('set_copy_barcode', barcode)

				this.$buefy.toast.open({
					duration: 500,
					message: 'Barcode copied',
					type: 'is-success',
					position: 'is-top'
				})

				this.$router.push('sales')
			}
		},

		// Reset search
		refreshSearch: function() {
			this.searchProductName = null
			this.searchBdCode = null
			this.searchBarcode = null
			this.searchStock = null
			this.searchChemicalName = ''
			this.selectedChemical = null

			this.getProducts()
		},

		// Load all chemicals from API
		loadChemicals: async function() {
			try {
				this.isLoadingChemicals = true
				const response = await this.$api.getChemicalList()
				this.allChemicals = response.data.list || []
				this.filteredChemicals = this.allChemicals
			} catch (error) {
				console.error('Error loading chemicals:', error)
				this.$buefy.toast.open({
					duration: 3000,
					message: 'Error loading chemicals',
					type: 'is-danger',
					position: 'is-top'
				})
			} finally {
				this.isLoadingChemicals = false
			}
		},

		// Filter chemicals based on user input (search both name and code)
		getFilteredChemicals: function(text) {
			this.filteredChemicals = this.allChemicals.filter(chemical => {
				return (
					chemical.name
						.toString()
						.toLowerCase()
						.indexOf(text.toLowerCase()) >= 0 ||
					chemical.code
						.toString()
						.toLowerCase()
						.indexOf(text.toLowerCase()) >= 0
				)
			})
		},

		// Handle chemical selection
		onChemicalSelect: function(option) {
			this.selectedChemical = option
			this.getProducts()
		},

		getProducts: async function() {
			this.page = 1
			var data = {
				limit: 0,
				skip: 0,
				sort: {
					createdAt: 'desc'
				}
			}

			if (this.searchProductName) {
				data.name = this.searchProductName
			}

			if (this.searchBdCode) {
				data.bd_code = this.searchBdCode
			}

			if (this.searchBarcode) {
				data.barcode = this.searchBarcode
			}

			if (this.selectedChemical && this.selectedChemical._id) {
				data.chemical_tree = [this.selectedChemical._id]
			}

			if (this.searchStock) {
				data.sort = { stock: 'desc' }
				data.advance_filters = {
					stock: {
						$lte: this.searchStock
					}
				}
			}

			var apiGetProducts = await this.$api.searchProduct({ data })

			// Calculate page count for pager
			this.pageCount = apiGetProducts.data.total / this.limit

			// if (!Number.isInteger(this.pageCount)) {
			this.pageCount = Math.ceil(this.pageCount)
			// }

			this.products = apiGetProducts.data.list

			// console.log(apiGetProducts);
		},

		// When user click on pager
		pagerClick: async function(pageNumber) {
			// Calculate how many items to skip
			var skip

			if (pageNumber == 1) {
				skip = 0
			} else {
				skip = (pageNumber - 1) * this.limit
			}

			var data = {
				limit: this.limit,
				skip,
				sort: {
					createdAt: 'desc'
				}
			}

			if (this.searchProductName) {
				data.name = this.searchProductName
			}
			if (this.searchBdCode) {
				data.bd_code = this.searchBdCode
			}
			if (this.searchBarcode) {
				data.barcode = this.searchBarcode
			}

			if (this.selectedChemical && this.selectedChemical._id) {
				data.chemical = { id: this.selectedChemical._id }
			}

			if (this.searchStock) {
				data.sort = { stock: 'desc' }
				data.advance_filters = {
					stock: {
						$lte: this.searchStock
					}
				}
			}

			const apiGetOrders = await this.$api.searchProduct({ data })

			// console.log(apiGetOrders);

			this.products = apiGetOrders.data.list
			this.page = pageNumber
		},

		// Generate payment method for styling
		getItemIndex: function(index) {
			var indexNumber = index + 1
			var itemNumber

			if (this.page > 1) {
				itemNumber = (this.page - 1) * this.limit + indexNumber
			} else {
				itemNumber = indexNumber
			}

			if (itemNumber < 10) {
				return '0' + itemNumber
			} else {
				return itemNumber
			}
		}
	}
}
</script>

<style scoped>
@import '../styles/ProductsList.css';

.unit-light {
	color: #aaa;
	font-size: 0.95em;
}
</style>
